import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ButtonLoader } from "components/__new/common/form";
import { ReactComponent as IconAngleLeft } from "assets/images/icons/project-icons/angle-left.svg";
import ComplianceHeader from "components/__new/compliance/ComplianceHeader";
import useBackButton from "hooks/useBackButton";
import { toast } from "react-toastify";
import PinInput from "react-pin-input";
import Maybe from "components/__new/common/Maybe";
import { Countdown } from "components/__new/common/Countdown";
import useLoginInfo from "hooks/useLoginInfo";
import { maskPhoneNumber } from "utils/maskData";
import ContentLoading from "components/__new/common/ContentLoading";
import * as complianceActions from "store/entities/compliance/action";
import * as bvnActions from "store/ui/bvn/action";
import * as accountActions from "store/auth/account/action";


const VerifyBvn = () => {
    let elementRef = useRef();
    const history = useHistory();
    const {goBack} = useBackButton();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { savedBvnInfo } = useSelector((s) => s.entities.compliance);
    const { bvnOtpValidationLoading, bvnOtpValidation, bvnOtpLoading, bvnOtp } = useSelector((s) => s.ui.bvn);
    const { profileUpdateLoading, profileUpdated } = useSelector((s) => s.auth.account);
    
    
    const [timerShown, setTimerShown] = useState(true);
    const [form, setForm] = useState({
        phoneNumber: savedBvnInfo.phoneNumber,
        otp: "",
    })
    
    
    const getDisabledStatus = () => {
        if (bvnOtpValidationLoading === true || form.otp.length < 6 || profileUpdateLoading === true){
            return true;
        }
        return false;
    }
    
    
    const resendOtp =() => {
        dispatch(bvnActions.sendBvnOtp({phoneNumber: form.phoneNumber}, userInfo.token));
    }
    
    
    const resetPin =() => {
        if (elementRef.currentIndex !== undefined){
            elementRef.clear();
            setForm({...form, otp: ""});
        }
    }
    
    
    const submitForm = async (e, exit=true) => {
        e?.preventDefault();
        dispatch(bvnActions.validateBvnOtp({otp: form.otp}, userInfo.token));
    }

    
    useEffect(() => {
        const {isCompliant, status} = userInfo.employer;
        
        if (isCompliant === true){
            history.push("/compliance/approval/success");
        }
        else if (isCompliant === false && status === "review"){
            history.push("/compliance/unregistered/approval");
        }
        else{
            if (savedBvnInfo?.phoneNumber === undefined || savedBvnInfo?.phoneNumber === ""){
                history.push("/compliance/unregistered/verify-bvn");
            }
            else{
                dispatch(complianceActions.updateComplianceProgress(75));
                resetPin();
            }
        }
        // eslint-disable-next-line
    }, [])
    
    
    useEffect(() => {
        if (bvnOtp.status === "success"){
            toast.success("A new OTP has been sent to " + form.phoneNumber);
            setTimerShown(true);
            dispatch(bvnActions.resetSendBvnOtp());
        }
        // eslint-disable-next-line
    }, [bvnOtp])
    
    
    useEffect(() => {
        if (bvnOtpValidation.status === "success"){
            dispatch(bvnActions.resetValidateBvnOtp());
            dispatch(complianceActions.saveBvnInfo({}));
            
            dispatch(accountActions.updateProfile({
                firstName: userInfo?.employer?.firstName ?? "",
                lastName: userInfo?.employer?.lastName ?? "",
                phoneNumber: userInfo?.employer?.phoneNumber ?? "",
                jobTitle: userInfo?.employer?.jobTitle ?? "",
                email: userInfo?.employer?.email ?? "",
                status: "review",
            }));
        }
        // eslint-disable-next-line
    }, [bvnOtpValidation])
    
    
    useEffect(() => {
        if (profileUpdated?.status === "success"){
            dispatch(accountActions.resetUpdateProfile());
            dispatch(accountActions.getEmployerInfo());
            history.push("/compliance/unregistered/approval");
        }
        // eslint-disable-next-line
    }, [profileUpdated])
    
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="Earnipay Compliance"
                headerDescription="Complete each step to access all Earnipay features"
            />
            
            <ComplianceHeader />
            
            <div className="pt-6 px-6 pb-24 sm:pt-10 sm:px-10">
                <div className="max-w-md mx-auto box">
                    
                    <div className="flex justify-start">
                        <div onClick={goBack} className="w-max h-8 pr-2 mr-1 flex items-center cursor-pointer">
                            <IconAngleLeft style={{ height: "16px" }} className="w-max pr-3 m-auto" />
                            Back
                        </div>
                    </div>
                    
                    <div className="pb-2 mt-8 text-center">
                        <div className="font-bold text-xl">
                            BVN Verfication
                        </div>
                        <div className="mt-2 text-fade text-sm">
                            Enter the OTP sent to {maskPhoneNumber(savedBvnInfo.phoneNumber)}
                        </div>
                    </div>
                        
                    <form onSubmit={submitForm} className="mt-14">
                        
                        <div className="flex justify-center">
                            <PinInput
                                length={6}
                                initialValue={form.otp}
                                onChange={(e) => {setForm({...form, otp: e}); getDisabledStatus()}}
                                inputStyle={{width: "45px", border: "none", borderBottom: "1px solid #ADB5BD", fontSize: "30px", fontWeight: "bold", paddingBottom: "6px"}}
                                inputFocusStyle={{borderBottom: "1px solid #ADB5BD"}}
                                onComplete={(value, index) => {}}
                                autoSelect={true}
                                focus={true}
                                secret={false}
                                ref={(n) => (elementRef = n)}
                            />
                        </div>
                        
                        <div className="mt-14 flex space-x-4">
                            <ButtonLoader type="submit" loading={bvnOtpValidationLoading === true || profileUpdateLoading === true} className="btn btn-ep-primary btn-block btn-lg" disabled={getDisabledStatus() === true}>
                                Submit
                            </ButtonLoader>
                        </div>
                        
                        <div className="mt-10 flex justify-center font-medium text-sm">
                            <Maybe condition={timerShown === true}>
                                <div className="font-medium text-fade cursor-not-allowed">Resend OTP</div>
                                <div>&nbsp;in&nbsp;</div>
                                <Countdown seconds={60} onExpiry={() => setTimerShown(false)} />
                            </Maybe>
                            
                            <Maybe condition={timerShown === false}>
                                <div>Didn't receive OTP? &nbsp;</div>
                                <Maybe condition={bvnOtpLoading === false}>
                                    <button type="button" onClick={resendOtp} className="font-medium text-ep-primary hover:underline">
                                        Resend OTP
                                    </button>
                                </Maybe>
                                <Maybe condition={bvnOtpLoading === true}>
                                    <span className="font-medium text-fade">
                                        <ContentLoading loading={true} />
                                        <span className="ml-1">Resend OTP</span>
                                    </span>
                                </Maybe>
                            </Maybe>
                        </div>
                    </form>
                        
                </div>
            </div>
            
        </div>
    )
}


export default VerifyBvn;